module.exports = __webpack_public_path__ + "img/success3.3b546411.png";